export const companiesCompanyIdOauthMcpSettingsMarketplaceClients =
  "/companies/:company_id/oauth_mcp_settings/marketplace_clients";
